import { render, staticRenderFns } from "./CampaignListItemPublisherFees.vue?vue&type=template&id=26525897&"
import script from "./CampaignListItemPublisherFees.vue?vue&type=script&lang=js&"
export * from "./CampaignListItemPublisherFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports